import IconAnimationLoadingSpinner from '@/assets/animations/animation_loading_spinner.svg?url';
import { HOOK_GRID2D_CELL__icon_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__icon_size';

import React from 'react';

interface PROPS {
  width: number;
  height: number;
}

export const GRID2D_CELL__loading_image = React.memo(({ height, width }: PROPS) => {
  /*
   * FIELDS
   */
  const { icon_width, icon_height } = HOOK_GRID2D_CELL__icon_size(width, height);

  /*
   * RENDERS
   */
  return (
    <div
      style={{ width, height }}
      className="   flex-center 
                    bg-component rounded-2xl 
                    border border-component-border 
                    cursor-loading"
    >
      <img src={IconAnimationLoadingSpinner} style={{ width: icon_width, height: icon_height }} alt="Loading" className="size-5" />
    </div>
  );
});
